import { render, staticRenderFns } from "./InformationSessionsPanel.vue?vue&type=template&id=924c6ae0&"
import script from "./InformationSessionsPanel.vue?vue&type=script&lang=js&"
export * from "./InformationSessionsPanel.vue?vue&type=script&lang=js&"
import style0 from "./InformationSessionsPanel.vue?vue&type=style&index=0&id=924c6ae0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports